<h2 class="mb-6">Punto de Venta</h2>

<div class="card w-full">
   <div class="border-b pb-4 mb-8 flex flex-row items-baseline">
      <h2 class="flex flex-row items-center flex-1">
         <fa-icon icon="store-alt" class="text-xl mr-2"></fa-icon>
         {{ commerce.name }}
      </h2>
      <button (click)=back() class="btn">
         <fa-icon icon="arrow-left"></fa-icon>
         Volver
      </button>
   </div>

   <div>
      <!-- Datos Generales -->
      <div>
         <h3 class="border-b my-4">
            <fa-icon icon="info-circle"></fa-icon>
            Datos Generales
         </h3>
         <table>
            <tr>
               <td class="label">
                  <div>Código de comercio:</div>
               </td>
               <td class="value">{{ commerce.code }}</td>
               <td class="label">
                  <div>Nombre del contacto:</div>
               </td>
               <td class="value">{{ commerce.contact_name }}</td>
            </tr>
            <tr>
               <td class="label">
                  <div>Dirección:</div>
               </td>
               <td class="value">{{ commerce.address }}</td>
               <td class="label">
                  <div>Teléfono del contacto:</div>
               </td>
               <td class="value">{{ commerce.contact_phone }}</td>
            </tr>
            <tr>
               <td class="label">
                  <div>Tipo de comercio:</div>
               </td>
               <td class="value">{{ commerce.type === 'FI'? 'Físico' : 'Virtual' }}</td>
               <td class="label">
                  <div>Teléfono móvil del contacto:</div>
               </td>
               <td class="value">{{ commerce.contact_mobile_phone }}</td>
            </tr>
            <tr>
               <td class="label">
                  <div>Documento:</div>
               </td>
               <td class="value">{{ commerce.document }}</td>
               <td class="label">
                  <div>Email del contacto:</div>
               </td>
               <td class="value">{{ commerce.contact_email }}</td>
            </tr>
            <tr>
               <td class="label">
                  <div>Estado Legal:</div>
               </td>
               <td class="value">{{ commerce.legal_status }}</td>
               <td class="label">
                  <div>Agencia:</div>
               </td>
               <td class="value">{{ commerce.agency.description }}</td>
            </tr>
            <tr>
              <td class="label">
                 <div>Activo:</div>
              </td>
              <td class="value">
                <input type="checkbox" checked *ngIf="commerce?.enabled; else enabledFalse" (click)='change_enabled(!commerce?.enabled)'>
                <ng-template #enabledFalse>
                  <input type="checkbox" (click)='change_enabled(!commerce?.enabled)'>
                </ng-template>
              </td>
           </tr>

           <tr>
               <td class="label">
                  <div>Es Cadena:</div>
               </td>
               <td class="value">
                  <input type="checkbox" [checked]="commerce?.ind_chain" disabled>
               </td>
            </tr>
         </table>
      </div>

      <!-- Información Bancaria y Financiera -->
      <div>
         <h3 class="border-b my-4">
            <fa-icon icon="university"></fa-icon>
            Información Bancaria y Financiera
         </h3>
         <table>
            <tr>
               <td class="label">
                  <div>Cuenta Bancaria:</div>
               </td>
               <td class="value">{{ commerce.bank_account }}</td>
               <td class="label">
                  <div>Tipo de Cuenta:</div>
               </td>
               <td class="value">{{ commerce.account_type }}</td>
            </tr>
            <tr> 
               <td class="label">
                  <div>Saldo:</div>
               </td>
               <td class="value">{{ commerce.balance | currency:'USD':'symbol':'1.2-2' }}</td>
               <td *ngIf="canUserRegisterPayment" class="label">
                  <div class="flex space-x-2">
                     <button (click)="openPaymentModal()" class="btn blue">
                        <fa-icon icon="dollar-sign"></fa-icon> Registrar Pago
                     </button>
                     <button (click)="openPaymentsModal()" class="btn">
                        <fa-icon icon="table"></fa-icon> Ver Pagos
                     </button>
                  </div>
               </td>
               <td class="value"></td>
            </tr>
            <tr>
               <td class="label">
                  <div>Usar Saldo:</div>
               </td>
               <td class="value">
                  <input type="checkbox" checked *ngIf="commerce?.use_balance; else balanceDisabled" disabled>
                  <ng-template #balanceDisabled>
                     <input type="checkbox" disabled>
                  </ng-template>
               </td>
               <td class="label"></td>
               <td class="value"></td>
            </tr>
         </table>
      </div>

     <!-- Facturadores y métodos de pago -->
      <div>
         <h3 class="border-b my-8">
            <fa-icon icon="handshake"></fa-icon>
            Facturadores y métodos de pago
         </h3>

         <div class="flex flex-row flex-wrap">
            <div *ngFor="let agency_invoicer of commerce.agency_invoicers" class="mb-6 mr-8">
               <h3>{{ agency_invoicer.invoicer.description }}</h3>
               
               <!-- Commission Information -->
               <div class="mb-4 p-3 bg-gray-50 rounded">
                  <h4 class="font-semibold text-sm mb-2">Comisiones:</h4>
                  <div class="text-sm">
                     <div class="mb-1">
                        <span class="font-medium">Prepago:</span> 
                        <span class="text-green-600">
                           {{ agency_invoicer.prepaid_commission }}
                           {{ agency_invoicer.prepaid_commission_type === 1 ? '%' : '$RD' }}
                        </span>
                     </div>
                     <div>
                        <span class="font-medium">Pospago:</span> 
                        <span class="text-blue-600">
                           {{ agency_invoicer.pospaid_commission }}
                           {{ agency_invoicer.pospaid_commission_type === 1 ? '%' : '$RD' }}
                        </span>
                     </div>
                  </div>
               </div>
               
               <!-- Payment Methods -->
               <div>
                  <h4 class="font-semibold text-sm mb-2">Métodos de pago:</h4>
                  <div *ngFor="let method of agency_invoicer.payment_methods" class="text-indigo-800">
                     - {{ method.description }}
                  </div>
               </div>
            </div>
         </div>
      </div>

      <!-- Transacciones -->
      <div>
         <h3 class="border-b mt-4 mb-8">
            <fa-icon icon="file-invoice-dollar"></fa-icon>
            Transacciones
         </h3>

         <!-- Búsqueda de transacciones -->
         <div class="flex flex-row items-end">
            <div class="mr-4">
               <h4><label for=date-start>Desde:</label></h4>
               <input type="date" id=date-start [(ngModel)]=start_date [max]=today class="border rounded">
            </div>
            <div class="mr-4">
               <h4><label for=date-end>Hasta:</label></h4>
               <input type="date" id=date-end [(ngModel)]=end_date [max]=today class="border rounded">
            </div>
            <div>
               <button (click)="query_transactions()" [disabled]="working" class="btn blue">
                  {{ !working? 'Consultar' : 'Consultado...' }}
                  <fa-icon icon=file-invoice-dollar *ngIf="!working"></fa-icon>
                  <busy *ngIf="working"></busy>
               </button>
            </div>
            <div class="ml-4">
               <button (click)="exportar_excel()" [disabled]="working" class="btn block max-w-[150px]">
                  <fa-icon icon=file-excel></fa-icon>
                  Exportar Detalle
               </button>
            </div>
            <div class="ml-4">
               <button (click)="exportar_csv_total()" [disabled]="working" class="btn block max-w-[150px]">
                  <fa-icon icon=file-csv></fa-icon>
                  Exportar Total
               </button>
            </div>
         </div>

         <!-- Listado de transacciones -->
         <div *ngIf=transactions class="mt-6">
            <app-transaction-table [transactions]="transactions"  (filterTransations)="GetFilter($event)" (isExtendedTable)="toogleExtendedTable($event)"></app-transaction-table>
         </div>
      </div>
   </div>

   <!-- Payment Modal -->
   <div *ngIf="showPaymentModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg w-96 max-w-md">
         <h3 class="text-lg font-semibold mb-4">Registrar Pago</h3>
         
         <form>
            <div class="mb-4">
               <label for="payment-date" class="block text-sm font-medium mb-2">Fecha del pago:</label>
               <input 
                  type="date" 
                  id="payment-date"
                  [(ngModel)]="payment_date"
                  name="paymentDate"
                  [max]="today"
                  class="w-full border rounded px-3 py-2"
                  required>
            </div>
            
            <div class="mb-4">
               <label for="payment-amount" class="block text-sm font-medium mb-2">Monto:</label>
               <input 
                  type="number" 
                  id="payment-amount"
                  [(ngModel)]="payment.amount"
                  name="paymentAmount"
                  step="0.01"
                  class="w-full border rounded px-3 py-2"
                  placeholder="Puede ser negativo"
                  required>
            </div>
            
            <div class="mb-4">
               <label for="payment-description" class="block text-sm font-medium mb-2">Descripción:</label>
               <textarea 
                  id="payment-description"
                  [(ngModel)]="payment.description"
                  name="paymentDescription"
                  rows="3"
                  class="w-full border rounded px-3 py-2"
                  placeholder="Descripción del pago"
                  required></textarea>
            </div>
            
            <div class="mb-6">
               <label for="payment-bank" class="block text-sm font-medium mb-2">Nombre del banco (si aplica):</label>
               <input 
                  type="text" 
                  id="payment-bank"
                  [(ngModel)]="payment.bank"
                  name="paymentBank"
                  class="w-full border rounded px-3 py-2"
                  placeholder="Opcional">
            </div>
            
            <div class="flex justify-end space-x-3">
               <button 
                  type="button" 
                  (click)="closePaymentModal()" 
                  class="btn"
                  [disabled]="processingPayment">
                  Cancelar
               </button>
               <button 
                  type="button" 
                  (click)="registerPayment()" 
                  class="btn blue"
                  [disabled]="processingPayment || !isPaymentValid()">
                  {{ processingPayment ? 'Procesando...' : 'Registrar Pago' }}
                  <fa-icon icon="save" *ngIf="!processingPayment"></fa-icon>
                  <busy *ngIf="processingPayment"></busy>
               </button>
            </div>
         </form>
      </div>
   </div>

   <!-- Payments Table Modal -->
   <div *ngIf="showPaymentsModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg w-full max-w-6xl max-h-[90vh] overflow-y-auto">
         <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold">Historial de Pagos</h3>
            <button (click)="closePaymentsModal()" class="btn">
               <fa-icon icon="times"></fa-icon>
               Cerrar
            </button>
         </div>

         <div *ngIf="loadingPayments" class="text-center py-8">
            <busy></busy>
            <p class="mt-2">Cargando pagos...</p>
         </div>

         <div *ngIf="!loadingPayments && payments.length === 0" class="text-center py-8 text-gray-500">
            No se encontraron pagos registrados
         </div>

         <div *ngIf="!loadingPayments && payments.length > 0" class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300">
               <thead>
                  <tr class="bg-gray-100">
                     <th class="border border-gray-300 px-4 py-2 text-left">Fecha</th>
                     <th class="border border-gray-300 px-4 py-2 text-left">Referencia</th>
                     <th class="border border-gray-300 px-4 py-2 text-right">Monto</th>
                     <th class="border border-gray-300 px-4 py-2 text-left">Descripción</th>
                     <th class="border border-gray-300 px-4 py-2 text-left">Banco</th>
                     <th class="border border-gray-300 px-4 py-2 text-left">User</th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngFor="let payment of payments" class="hover:bg-gray-50">
                     <td class="border border-gray-300 px-4 py-2">{{ payment.date }}</td>
                     <td class="border border-gray-300 px-4 py-2">{{ payment.reference }}</td>
                     <td class="border border-gray-300 px-4 py-2 text-right" 
                         [class.text-green-600]="payment.amount > 0"
                         [class.text-red-600]="payment.amount < 0">
                        {{ payment.amount | currency:'USD':'symbol':'1.2-2' }}
                     </td>
                     <td class="border border-gray-300 px-4 py-2">{{ payment.description }}</td>
                     <td class="border border-gray-300 px-4 py-2">{{ payment.bank || '-' }}</td>
                     <td class="border border-gray-300 px-4 py-2">{{ payment.user}}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>
</div>